module.exports = __webpack_public_path__ + "static/summary.f354bc7b.png";